import React, { useEffect, useState } from "react";
import isEmpty from "../../utils/is-Empty";
import inputValidation from "../../utils/inputValidation";
import { Row, Col, Form, Button, InputGroup, Modal, Container, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../common/CustomButton";
import CustomDragDrop from "../common/CustomDragDrop";
import axios from "axios";
import { BHAREE_BASE_URL_LOCAL } from "../../config/config.url";
import { stringConstants } from "../../helpers";
import PageSpinner from "../common/PageSpinner";
import OtpModal from "../common/OtpModal";
import { toast } from "react-toastify";
import { useDialog } from "../../helpers/useDialog";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { normalizeImages } from "../../utils/normalizeImages";
import { getApi } from "../../actions/structure.action";

const LogisticPartnerAuth = ({
  lpDetails = {},
  closeButtonTitle = "List",
  closeButtonFunction,
  fromRegister = false,
  fromSubscriptionUpgrade = false,
}) => {
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [errorMsg, setErrorMsg] = useState({});
  const [uploadFormObj, setUploadFormObj] = useState({});
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const { alert, confirm, DialogModal } = useDialog();
  const [vehicleTypesList, setVehicleTypesList] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { requestCall, auth, guestJWTToken, vehicleTypes } = useSelector((state) => state);

  let options = {
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.jwtToken}`,
    },
  };

  useEffect(() => {
    if (!isEmpty(vehicleTypes) && !isEmpty(vehicleTypes?.data) && vehicleTypes?.data.length > 0) {
      setVehicleTypesList(vehicleTypes?.data);
    } else {
      setVehicleTypesList([]);
    }
  }, [vehicleTypes]);

  useEffect(() => {
    setStatesList([]);
    setDistrictList([]);
    setCityList([]);

    // console.log("INSIDE LP AUTH: ", guestJWTToken);
    if (!isEmpty(guestJWTToken) && !isEmpty(guestJWTToken?.data)) {
      getGeoDataDB("state");
      getApi("getVehicleTypes", dispatch);
    }

    setIsCreateMode(false);
    if (isEmpty(lpDetails)) {
      setIsCreateMode(true);
    } else {
      setIsVerified(true);
    }
  }, [guestJWTToken]);

  useEffect(() => {
    if (lpDetails && Object.keys(lpDetails).length > 0) {
      setUploadFormObj({
        ...uploadFormObj,
        ...lpDetails.business_info,
        contact_person_name: lpDetails.contact_person_name,
        driver_email: lpDetails.email,
        driver_contact: lpDetails.mobile_number,
        driver_name: lpDetails.business_info.business_name,
        logistic_vehicle_type: lpDetails.business_info.vehicle_type_id,
      });

      console.log("LP Details: ", lpDetails);
      if (!isEmpty(lpDetails?.business_info?.state)) {
        console.log("Fetching the districts....", lpDetails?.business_info?.state);
        getGeoDataDB("district", lpDetails?.business_info?.state);
      }
      if (!isEmpty(lpDetails?.business_info?.district)) {
        console.log("Fetching the cities....", lpDetails?.business_info?.district);
        getGeoDataDB("city", lpDetails?.business_info?.state, lpDetails?.business_info?.district);
      }
    }
  }, [lpDetails, guestJWTToken]);

  const onSelectValue = (key, value) => {
    // console.log("*** change ", key, value)
    let updatedObj = {};
    updatedObj[key] = value;

    setUploadFormObj((previousVlaues) => ({
      ...previousVlaues,
      ...updatedObj,
    }));
  };

  const onSelectValueValidation = (key, value, maxLength = 1000, numericOnly = false) => {
    setErrorMsg({});
    let updatedObj = {};
    let validate = inputValidation(value, maxLength, numericOnly);
    if (validate.pass) {
      updatedObj[key] = validate.finalValue;
      setUploadFormObj((previousValues) => ({
        ...previousValues,
        ...updatedObj,
      }));
    } else {
      setErrorMsg({ [key]: validate.msg });
    }
  };

  const [statesList, setStatesList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const getGeoDataDB = async (action, stateName, districtName) => {
    let apiURL = BHAREE_BASE_URL_LOCAL + "/api/geoDataDB?countryCode=IN";
    if (districtName) {
      apiURL += `&districtName=${encodeURIComponent(districtName)}`;
    }
    if (stateName) {
      apiURL += `&stateName=${encodeURIComponent(stateName)}`;
    }

    try {
      // console.log("getGeoDataDB: ACTION: ", action);
      // console.log("getGeoDataDB: guest_jwt_token: ", localStorage.guest_jwt_token);
      const res = await axios.get(apiURL, {
        headers: {
          ...options.headers,
          "x-guest-token": `${localStorage.guest_jwt_token}`,
        },
      });
      if (res.data.success) {
        if (action === "state") {
          setStatesList(res.data.data);
          return;
        }
        if (action === "district") {
          setDistrictList(res.data.data);
          return;
        }
        if (action === "city") {
          setCityList(res.data.data);
          return;
        }
      } else {
        console.error("Failed to fetch geo data:", res.data.message);
      }
    } catch (error) {
      console.error("Error fetching geo data:", error);
    }
  };

  const createUpdateLP = async (e) => {
    e.preventDefault();
    console.log("Form Submitted: ", uploadFormObj);

    const formData = new FormData();

    if (isCreateMode) {
      if (auth?.user?.role?.role_name === stringConstants.ROLL_SELLER) {
        formData.append("seller_id", auth?.user?.id);
      } else if (auth?.user?.role?.role_name === stringConstants.ROLL_BHAREE) {
        formData.append("bharee_id", auth?.user?.id);
      }
    }

    let mErrors = [];
    if (isEmpty(uploadFormObj?.state)) {
      mErrors.push("Please select state.");
    }
    if (isEmpty(uploadFormObj?.district)) {
      mErrors.push("Please select district.");
    }
    if (isEmpty(uploadFormObj?.city)) {
      mErrors.push("Please select city.");
    }
    if (isEmpty(uploadFormObj?.logistic_vehicle_type)) {
      mErrors.push("Please select vehicle make and type.");
    }
    if (mErrors.length > 0) {
      await alert(mErrors.join("<br/>"));
      return;
    }

    // Loop through each key in uploadFormObj
    for (const key in uploadFormObj) {
      const value = uploadFormObj[key];

      if (Array.isArray(value)) {
        for (const item of value) {
          if (item.file instanceof File) {
            formData.append(key, item.file, item.file.name);
          } else if (item.file?.path) {
            // Fetch path as blob if using a URL
            const blob = await fetch(item.file.path).then((r) => r.blob());
            formData.append(key, blob, item.file.path);
          }
        }
      } else {
        // This is a simple field
        formData.append(key, value);
      }
    }

    if (isVerified && !formData.has("mobile_number_verify_status")) {
      formData.append("mobile_number_verify_status", 1);
    }

    setLoading(true);
    try {
      let response = null;

      if (isCreateMode) {
        const registerUrl = fromRegister
          ? BHAREE_BASE_URL_LOCAL + "/api/registerLogisticPartner"
          : BHAREE_BASE_URL_LOCAL + "/logistics";

        const requestHeaders = fromRegister
          ? {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
              "x-guest-token": `${localStorage.guest_jwt_token}`,
            }
          : {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
              Authorization: `Bearer ${localStorage.jwtToken}`,
            };

        response = await axios.post(registerUrl, formData, {
          headers: requestHeaders,
        });
      } else {
        response = await axios.patch(
          BHAREE_BASE_URL_LOCAL + "/logistics/" + lpDetails?.business_info?.logistic_partner_id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
              Authorization: `Bearer ${localStorage.jwtToken}`,
            },
          }
        );
      }

      console.log("Success: ", response);

      if (response && response.data) {
        if (response.data.success) {
          toast.success(response.data.message);

          if (fromRegister) {
            if (fromSubscriptionUpgrade) {
              dispatch({
                type: stringConstants.SET_CURRENT_VIEW,
                payload: stringConstants.MY_SUBSCRIPTIONS,
              });
            } else {
              navigate("/", { state: { scrollToBottom: true } });
            }
          }
        } else {
          toast.error(response.data.message);
        }

        // Close this page and move to the previous one
        setIsCreateMode(false);
        setUploadFormObj({});
        setErrorMsg({});
        closeButtonFunction();
      }
      return response;
    } catch (error) {
      console.error("Upload error:", error.response || error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (files, nameKey) => {
    // const files = e.target.files;
    // console.log("**********files", files, nameKey)
    const newImageData = [];
    for (let i = 0; i < files?.length; i++) {
      let imageKey = `image_${i + 1}`;
      // !isEmpty(nameKey) ? imageKey = `${nameKey}_${i + 1}` : imageKey = `image_${i + 1}`;
      // Generate a unique key for each image
      // console.log("**********file", files[0])
      newImageData.push({ key: imageKey, file: files[i] });
    }

    // setImageData(newImageData);
    // let updatedObj = {};
    // updatedObj[selectorType] = value;
    if (Object.prototype.hasOwnProperty.call(uploadFormObj, "imageData")) {
      setUploadFormObj((prevState) => {
        const newArray = [...prevState.imageData];
        newImageData.map((item) => {
          return newArray.push(item);
        });
        return { ...prevState, imageData: newArray };
      });
    } else {
      let updatedObj = {};
      !isEmpty(nameKey)
        ? (updatedObj[nameKey] = newImageData)
        : (updatedObj["imageData"] = newImageData);
      // updatedObj["imageData"] = newImageData;
      setUploadFormObj((previousVlaues) => ({
        ...previousVlaues,
        ...updatedObj,
      }));
    }
  };

  const handleSendOtp = async () => {
    try {
      setLoading(true);
      // Call your API to send OTP
      const response = await axios.post(
        BHAREE_BASE_URL_LOCAL + "/auth/getOtp",
        {
          mobile_number: uploadFormObj.driver_contact,
          fromRegister: fromRegister,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "x-guest-token": `${localStorage.guest_jwt_token}`,
          },
        }
      );

      if (response && response?.data?.success) {
        setShowOtpModal(true);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error("OTP send error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGoToSubscription = () => {
    dispatch({
      type: stringConstants.SET_CURRENT_VIEW,
      payload: stringConstants.MY_SUBSCRIPTIONS,
    });
  };

  return (
    <>
      {DialogModal}
      {loading && <PageSpinner />}
      <OtpModal
        show={showOtpModal}
        onHide={() => setShowOtpModal(false)}
        contact={uploadFormObj.driver_contact}
        onVerified={() => {
          setIsVerified(true);
          setShowOtpModal(false);
          onSelectValue("mobile_number_verify_status", 1);
        }}
      />
      <Container fluid={!fromRegister ? true : false}>
        {fromSubscriptionUpgrade && (
          <Alert variant="info" className="m-0 p-2 mt-2">
            After the Logistic Partner Registration is complete, please go to the{" "}
            <Button variant="link" className="p-0" onClick={handleGoToSubscription}>
              Subscription
            </Button>{" "}
            page for an upgrade.
          </Alert>
        )}

        <Row className="m-0 form-row">
          {!fromRegister ? (
            <Row className="m-0 px-0 w-full px-0 title-button-row">
              <h2>{isCreateMode ? "Add Logistic Partner" : "Update Logistic Partner"}</h2>
              <CustomButton
                buttonClasses="view-switch-btn"
                onClick={() => {
                  setIsCreateMode(false);
                  setUploadFormObj({});
                  setErrorMsg({});
                  closeButtonFunction();
                }}
              >
                {isCreateMode ? <i className="bi bi-list"></i> : <i className="bi bi-eye"></i>}{" "}
                {closeButtonTitle}
              </CustomButton>
            </Row>
          ) : (
            <Row className="m-0 px-0 w-full px-0">
              <Col xs={12} className="text-center">
                <h2>Logistic Partner Registration</h2>
              </Col>
            </Row>
          )}
          <Form className="modal-custom-class" onSubmit={createUpdateLP}>
            <Row className="m-0">
              {!fromRegister && <h4>{"Basic Info"}</h4>}
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {!fromRegister ? "Driver Contact Number" : "Mobile Number"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      value={uploadFormObj?.driver_contact || ""}
                      required
                      onChange={(e) =>
                        onSelectValueValidation("driver_contact", e.target.value, 10, true)
                      }
                      disabled={isVerified} // prevent editing after verification
                      maxLength={10}
                    />
                    {!isVerified ? (
                      <Button
                        variant="primary"
                        onClick={handleSendOtp}
                        disabled={loading || !uploadFormObj?.driver_contact}
                      >
                        {loading ? "Sending..." : "Verify"}
                      </Button>
                    ) : (
                      <span className="ms-2 text-success" style={{ marginTop: "5px" }}>
                        <i class="bi bi-patch-check-fill"></i> Verified
                      </span>
                    )}
                  </InputGroup>
                </Form.Group>
              </Col>
              {isVerified && (
                <>
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"Driver Name"}
                        <span className="redStreSpan">{"*"}</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={uploadFormObj?.driver_name || ""}
                        required
                        onChange={(e) => onSelectValueValidation("driver_name", e.target.value, 50)}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"Driver Email"}
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        value={uploadFormObj?.driver_email || ""}
                        required
                        onChange={(e) => onSelectValue("driver_email", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"Driver License Number"}
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        required
                        value={uploadFormObj?.driver_license_no || ""}
                        onChange={(e) =>
                          onSelectValueValidation("driver_license_no", e.target.value, 20)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"Driver License Copy (PNG/JPG/PDF ≤ 2MB)"}
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <CustomDragDrop
                        onUplodfiles={handleFileChange}
                        nameKey={"driver_license_copy"}
                        allowMultiple={false}
                        existingFiles={
                          lpDetails?.business_info?.driver_license_copy
                            ? [lpDetails?.business_info?.driver_license_copy]
                            : []
                        }
                      />
                    </Form.Group>
                  </Col>

                  <h4>Location Details</h4>
                  <Col xs={12} md={4} className="mb-3">
                    <Form.Group className="mb-3">
                      <Form.Label>
                        State <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        value={
                          uploadFormObj?.state
                            ? { value: uploadFormObj?.state, label: uploadFormObj?.state }
                            : null
                        }
                        onChange={(selected) => {
                          onSelectValue("state", selected?.value || "");
                          getGeoDataDB("district", selected?.value);
                          onSelectValue("district", "");
                          onSelectValue("city", "");
                        }}
                        options={statesList.map((s) => ({
                          value: s.state_name,
                          label: s.state_name,
                        }))}
                        placeholder="-- Select State --"
                        isSearchable={true}
                        className="react-select-container"
                        classNamePrefix="react-select-register"
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={4} className="mb-3">
                    <Form.Group className="mb-3">
                      <Form.Label>
                        District <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        value={
                          uploadFormObj?.district
                            ? { value: uploadFormObj?.district, label: uploadFormObj?.district }
                            : null
                        }
                        onChange={(selected) => {
                          onSelectValue("district", selected?.value || "");
                          getGeoDataDB("city", uploadFormObj?.state, selected?.value);
                          onSelectValue("city", "");
                        }}
                        options={districtList.map((d) => ({
                          value: d.district_name,
                          label: d.district_name,
                        }))}
                        placeholder="-- Select District --"
                        isSearchable={true}
                        className="react-select-container"
                        classNamePrefix="react-select-register"
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={4} className="mb-3">
                    <Form.Group className="mb-3">
                      <Form.Label>
                        City <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        value={
                          uploadFormObj?.city
                            ? { value: uploadFormObj?.city, label: uploadFormObj?.city }
                            : null
                        }
                        onChange={(selected) => {
                          onSelectValue("city", selected?.value || "");
                        }}
                        options={cityList.map((c) => ({
                          value: c.city_name,
                          label: c.city_name,
                        }))}
                        placeholder="-- Select City --"
                        isSearchable={true}
                        className="react-select-container"
                        classNamePrefix="react-select-register"
                      />
                    </Form.Group>
                  </Col>

                  <h4>Vehicle Details</h4>
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"Vehicle Owner Name"}
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={uploadFormObj?.vehicle_owner_name || ""}
                        required
                        onChange={(e) =>
                          onSelectValueValidation("vehicle_owner_name", e.target.value, 50)
                        }
                      />
                      {!isEmpty(errorMsg.vehicle_owner_name) && (
                        <p className="error-msg">{errorMsg.vehicle_owner_name}</p>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"Registration Number"}
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={uploadFormObj?.vehicle_reg_no || ""}
                        required
                        style={{ textTransform: "uppercase" }} // 👈 makes text appear uppercase
                        onChange={(e) =>
                          onSelectValueValidation(
                            "vehicle_reg_no",
                            e.target.value.toUpperCase(),
                            11
                          )
                        }
                        maxLength={11}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"RC Number"}
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        required
                        value={uploadFormObj?.vehicle_rc_no || ""}
                        onChange={(e) =>
                          onSelectValueValidation("vehicle_rc_no", e.target.value, 50)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"Vehicle Make & Type"}
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <Select
                        value={
                          uploadFormObj?.logistic_vehicle_type
                            ? {
                                value: uploadFormObj?.logistic_vehicle_type,
                                label: vehicleTypesList.find(
                                  (vt) => vt.id === uploadFormObj?.logistic_vehicle_type
                                )?.label,
                              }
                            : null
                        }
                        onChange={(selected) => {
                          console.log("---> selected: ", selected);
                          onSelectValue("logistic_vehicle_type", selected?.value || null);
                          onSelectValue(
                            "vehicle_make",
                            vehicleTypesList.find((vt) => vt.id === selected.value)?.make
                          );
                          onSelectValue(
                            "vehicle_payload_capacity",
                            vehicleTypesList.find((vt) => vt.id === selected.value)?.max_payload
                          );
                        }}
                        options={vehicleTypesList.map((s) => ({
                          value: s.id,
                          label: s.label,
                        }))}
                        placeholder="-- Select Vehicle Make & Type --"
                        isSearchable={true}
                        className="react-select-container"
                        classNamePrefix="react-select-register"
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Per KM Rate
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={uploadFormObj?.per_km_rate || ""}
                        required
                        onChange={(e) => onSelectValueValidation("per_km_rate", e.target.value, 20)}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Body Type</Form.Label>
                      <Form.Control
                        type="text"
                        disabled
                        value={uploadFormObj?.vehicle_body_type || "Covered"}
                        onChange={(e) =>
                          onSelectValueValidation("vehicle_body_type", e.target.value, 50)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"RC Copy (PNG/JPG/PDF ≤ 2MB)"}
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <CustomDragDrop
                        onUplodfiles={handleFileChange}
                        nameKey={"vehicle_rc_copy"}
                        allowMultiple={false}
                        existingFiles={
                          lpDetails?.business_info?.vehicle_rc_copy
                            ? [lpDetails?.business_info?.vehicle_rc_copy]
                            : []
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"Insurance Copy (PNG/JPG/PDF ≤ 2MB)"}
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <CustomDragDrop
                        onUplodfiles={handleFileChange}
                        nameKey={"insurance_copy"}
                        allowMultiple={false}
                        existingFiles={
                          lpDetails?.business_info?.insurance_copy
                            ? [lpDetails?.business_info?.insurance_copy]
                            : []
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"Transport Permit Copy (PNG/JPG/PDF ≤ 2MB)"}
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <CustomDragDrop
                        onUplodfiles={handleFileChange}
                        nameKey={"transport_permit_copy"}
                        allowMultiple={false}
                        existingFiles={
                          lpDetails?.business_info?.transport_permit_copy
                            ? [lpDetails?.business_info?.transport_permit_copy]
                            : []
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {"Vehicle Images (Front, Back, Side) (PNG/JPG ≤ 2MB)"}
                        <span className="redStreSpan">*</span>
                      </Form.Label>
                      <CustomDragDrop
                        onUplodfiles={handleFileChange}
                        nameKey={"vehicle_images"}
                        allowMultiple={true}
                        existingFiles={normalizeImages(lpDetails?.business_info?.vehicle_images)}
                      />
                    </Form.Group>
                  </Col>

                  {isCreateMode && (
                    <>
                      <h4>{"Bank Details"}</h4>
                      <Col xs={12} md={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            {"Account Name"}
                            <span className="redStreSpan">{"*"}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={uploadFormObj?.account_name}
                            onChange={(e) => onSelectValue("account_name", e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            {"Account Number"}
                            <span className="redStreSpan">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={uploadFormObj?.account_number}
                            onChange={(e) => onSelectValue("account_number", e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            {"Bank Name"}
                            <span className="redStreSpan">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={uploadFormObj?.bank_name}
                            onChange={(e) => onSelectValue("bank_name", e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            {"IFSC"}
                            <span className="redStreSpan">{"*"}</span>
                          </Form.Label>

                          <Form.Control
                            type="text"
                            required
                            value={uploadFormObj?.ifsc}
                            onChange={(e) => onSelectValue("ifsc", e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            {"Bank Address"}
                            <span className="redStreSpan">{"*"}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={uploadFormObj?.bank_address}
                            onChange={(e) => onSelectValue("bank_address", e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            {"Upload Cancelled Cheque (PNG/JPG/PDF ≤ 2MB)"}
                            <span className="redStreSpan">*</span>
                          </Form.Label>
                          <CustomDragDrop
                            onUplodfiles={handleFileChange}
                            nameKey={"cancelled_cheque"}
                            allowMultiple={false}
                          />
                        </Form.Group>
                      </Col>
                    </>
                  )}
                </>
              )}
            </Row>

            {isVerified && (
              <div className="action-buttons">
                {fromRegister && (
                  <CustomButton
                    buttonClasses="close-btn"
                    onClick={() => {
                      navigate("/");
                    }}
                    disabled={requestCall?.loading}
                  >
                    <i className="bi bi-x-lg"></i> {"Close"}
                  </CustomButton>
                )}

                <CustomButton
                  buttonClasses={!requestCall?.loading ? "submit-btn" : "submit-btn-loading"}
                  type="submit"
                  loading={requestCall?.loading}
                >
                  <i className="bi bi-floppy"></i> {isCreateMode ? "Create" : "Update"}
                </CustomButton>
              </div>
            )}
          </Form>
        </Row>
      </Container>
    </>
  );
};

export default LogisticPartnerAuth;
